export default "__VITE_ASSET__B$u6x4uO__"